import { BFF_BASE_PATH } from "@/core/utils"

$(function () {
  var init = function () {
    $.ajax({
      url: `${BFF_BASE_PATH}/keyboard-shortcuts`,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function (data) {
        createPopup(data);
      },
    });
  };

  var $popup = $("<div />").addClass("kb-shortcuts-popup");

  var createPopup = function (data) {
    $popup
      .append(
        `<div class="popup-title">${window.app.t("shortcuts.header")} <span>${window.app.t(
          "shortcuts.press_to_hide"
        )}</span></div>`
      )
      .append('<div class="sections-container" />');

    data.forEach(createSection);
    $popup.appendTo("body");
  };

  var createSection = function (sectionData) {
    var $section = $("<div />").addClass("section");
    $section.append(`<div class="section-title">${sectionData.title}</div>`);
    var getKeysHtml = function (keys) {
      var html = [];
      for (var i = 0; i < keys.length; i++) {
        if (i > 0) html.push(" ");
        html.push(`<span class="keyboard-key">${keys[i]}</span>`);
      }
      return html.join("");
    };
    for (var i in sectionData.commands) {
      var command = sectionData.commands[i];
      var $commandContainer = $('<div class="command" />');
      $commandContainer
        .append(`<span class="keys">${getKeysHtml(command.keys)}</span>`)
        .append(`<span class="description">${window.app.t(`config.keyboard.${sectionData.title}.commands.${command.description}.description`)}</span>`)
        .appendTo($section);
    }
    $section.appendTo($popup.find(".sections-container"));
  };

  $("body").bind("config-ready", function (e, config) {
    if (config["enable_keyboard_shortcuts_menu"]) {
      init();
    }
    $(document).on("keyup", function (e) {
      if (e.key === "?") {
        $popup.toggle();
      }
    });
  });
});
